<template>
	<v-template>
		<v-row>
			<v-col cols="12" class="display-1 text-center">
				Pago
			</v-col>
		</v-row>
		<v-row style="position: relative; min-height: 300px;">
			<!-- Overlay montos -->
			<v-overlay absolute :value="cargandoMontos" opacity="0.75" color="white">
				<v-row>
					<v-col cols="12" class="d-flex justify-center">
						<v-progress-circular :size="150" :width="15" indeterminate color="primary"/>
					</v-col>
					<v-col cols="12" class="text-center text--primary">
						<span v-if="!hayMontos">
							Calculando montos...
						</span>
						<span v-else>
							Recalculando montos...
						</span>
					</v-col>
				</v-row>
			</v-overlay>
			<!-- Overlay de término de orden -->
			<v-overlay absolute :value="cursandoOrden" opacity="0.75" color="white">
				<v-row>
					<v-col cols="12" class="d-flex justify-center">
						<v-progress-circular :size="150" :width="15" indeterminate color="primary"/>
					</v-col>
					<v-col cols="12" class="text-center text--primary">
						Por favor espere...<br>
						{{ nombreTareaEnCurso }}...
					</v-col>
				</v-row>
			</v-overlay>
			<!-- Montos y pago -->
			<template v-if="hayMontos">
				<v-col cols="12" md="6">
					<v-card outlined color="grey lighten-4" class="pa-2 my-3" height="100%">
						<v-row dense>
							<v-col cols="12" class="title">
								Montos
							</v-col>
							<v-col cols="12" sm="6" class="font-weight-black">
								Valor Subtotal sin Iva
							</v-col>
							<v-col cols="12" sm="6">
								$ {{ formatearMoneda(montos.valorSubtotal) }}.-
							</v-col>
							<v-col cols="12" sm="6" class="font-weight-black">
								Valor Iva {{ montos.iva*100 }}%
							</v-col>
							<v-col cols="12" sm="6">
								$ {{ formatearMoneda(montos.valorIva) }}.-
							</v-col>
							<v-col cols="12" sm="6" class="font-weight-black">
								Cupón descuento
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field v-show="!hayCupon" v-model="inputCupon" label="Ingrese cupón" 
									clearable ref="inputCupon" hide-details class="pt-0">
									<template v-slot:append-outer>
										<v-tooltip top>
											<template v-slot:activator="{ on, attrs }">
												<v-btn small depressed @click="aplicarCupon" color="primary" 
													:disabled="!puedeAplicarCupon" v-on="on">
													Aplicar
												</v-btn>
											</template>
											<span>
												Aplicar cupón. Se recalcularán los montos.
											</span>
										</v-tooltip>
									</template>
								</v-text-field>
								<div v-show="hayCupon">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<v-chip close close-icon="close" @click:close="eliminarCupon" color="primary" v-on="on">
												<span>
													<b>{{ montos.cupon }}</b>
												</span>
											</v-chip>
										</template>
										<span v-if="montos.cuponDescuentoIncorporacionMontoConIva">
											${{ formatearMoneda(montos.cuponDescuentoIncorporacionMontoConIva) }}.- (IVA incl.)
											sobre incorporación
										</span>
										<span v-if="montos.cuponDescuentoIncorporacionFactor">
											{{ montos.cuponDescuentoIncorporacionFactor*100 }}%
											sobre incorporación
										</span>
									</v-tooltip>
								</div>
							</v-col>
							<v-col cols="12">
								<v-divider/>
							</v-col>
							<v-col cols="12" sm="6" class="font-weight-black" v-if="montos.valorTotalDescuentoConIva">
								Valor Subtotal con Iva
							</v-col>
							<v-col cols="12" sm="6" v-if="montos.valorTotalDescuentoConIva">
								$ {{ formatearMoneda(montos.valorSubtotalConIva) }}.-
							</v-col>
							<v-col cols="12" sm="6" class="font-weight-black" v-if="montos.valorTotalDescuentoConIva">
								Descuento Total con Iva
							</v-col>
							<v-col cols="12" sm="6" v-if="montos.valorTotalDescuentoConIva">
								$ {{ formatearMoneda(montos.valorTotalDescuentoConIva) }}.-
							</v-col>
							<v-col cols="12" sm="6" class="font-weight-black">
								Valor Total con Iva
							</v-col>
							<v-col cols="12" sm="6" class="headline">
								$ {{ formatearMoneda(montos.valorTotalConIva) }}.-
							</v-col>
							<v-col cols="12">
								Por concepto de:<br>
								<ul>
									<li>
										1x Incorporación a <b>{{ plan.nombre }}</b> para 
										<b>{{ cantidad }} {{ cantidad > 1 ? plan.unidadCantidadPlural : plan.unidadCantidadSingular }}</b>
									</li>
									<li v-for="datoAdicional in datosAdicionales">
										{{ datoAdicional.cantidad }}x Adicional <b>{{ datoAdicional.adicional.nombre }}</b> 
									</li>
								</ul>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col cols="12" md="6">
					<!-- Pago normal, con medio de pago -->
					<v-card v-if="!esVentaAsistida" outlined color="grey lighten-4" class="pa-2 my-3" height="100%" >
						<v-row dense>
							<v-col cols="12" class="title">
								Pagar
							</v-col>
							<v-col cols="12" class="d-flex flex-column align-center">
								<div class="caption">
									Seleccione medio de pago
									<v-progress-circular indeterminate color="primary" size="16" v-show="cargandoMediosPago" />
								</div>
								<v-radio-group v-model="medioPago" class="ma-1" hide-details>
									<v-radio-group v-model="medioPago" class="ma-1" hide-details>
									<v-radio :value="mediosPago[0]">
										<template v-slot:label>
											<div>
												<v-avatar left>
													<img :src="mediosPago[0].urlAvatar" />
												</v-avatar>
												{{ mediosPago[0].nombre }}
											</div>
										</template>
									</v-radio>
									<v-expansion-panels>
									    <v-expansion-panel>
									      <v-expansion-panel-header>
									        Otros Medios de Pago
									      </v-expansion-panel-header>
									      <v-expansion-panel-content>
									        <v-radio :value="mediosPago[1]">
											<template v-slot:label>
												<div>
													<v-avatar left>
														<img :src="mediosPago[1].urlAvatar" />
													</v-avatar>
													{{ mediosPago[1].nombre }}
												</div>
											</template>
										</v-radio>
									      </v-expansion-panel-content>
									    </v-expansion-panel>
									  </v-expansion-panels>
									<!--<v-radio v-for="medioPago in mediosPago" :value="medioPago">-->
									<!--	<template v-slot:label>-->
									<!--		<div>-->
									<!--			<v-avatar left>-->
									<!--				<img :src="medioPago.urlAvatar" />-->
									<!--			</v-avatar>-->
									<!--			{{ medioPago.nombre }}-->
									<!--		</div>-->
									<!--	</template>-->
									<!--</v-radio>-->
								</v-radio-group>
								</v-radio-group>
							</v-col>
							<v-col cols="12" class="d-flex justify-center">
								<vue-recaptcha ref="recaptchaInput" @verify="recaptchaVerificado" @expired="recaptchaExpirado"
									:sitekey="clavePublicaRecaptcha" :loadRecaptchaScript="true" size="compact" @error="recaptchaError"/>
								<div class="d-flex flex-column">
									<ayuda tema="recaptcha"/>
									<v-tooltip top max-width="400">
										<template v-slot:activator="{ on, attrs }">
											<v-btn color="primary" fab dark x-small depressed @click="reiniciarRecaptcha" v-bind="attrs" v-on="on">
												<v-icon dark>
													refresh
												</v-icon>
											</v-btn>
										</template>
										<span>
											Reiniciar el reCAPTCHA. Use este botón en caso que no aparezca la casilla "No soy un robot"
											o bien la verificación haya expirado sin que exhiba dicha casilla nuevamente.
										</span>
									</v-tooltip>
								</div>
							</v-col>
							<v-col cols="12" class="d-flex justify-center">
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="warning" @click="modalContratoMostrar" class="ma-1" x-large depressed
													 :disabled="!puedePagar || cursandoOrden" v-on="on">
											<v-icon left>
												payment
											</v-icon>
											Pagar ${{ formatearMoneda(montos.valorTotalConIva) }}.-
										</v-btn>
									</template>
									<span>
										Revisar contrato y proceder a pago
									</span>
								</v-tooltip>
							</v-col>
							<v-col cols="12" v-if="pagoDesactivado">
								<v-alert type="error">
									El pago está momentáneamente desactivado debido a problemas técnicos.
									Lamentamos las molestias.
								</v-alert>
							</v-col>
						</v-row>
					</v-card>
					<!-- Venta asistida por vendedor, no hay pago -->
					<v-card v-else outlined color="grey lighten-4" class="pa-2 my-3" height="100%">
						<v-form v-model="formularioTerminarVentaValido">
							<v-row dense>
								<v-col cols="12" class="title">
									Venta asistida
								</v-col>
								<v-col cols="12">
									Suba aquí el comprobante de pago por <b>${{ formatearMoneda(montos.valorTotalConIva) }}.-</b>
									<v-file-input v-model="archivoComprobantePago" label="Archivo con comprobante de pago" :show-size="true"
																clearable prepend-inner-icon="insert_drive_file" :rules="[validarArchivoComprobantePago]"
																ref="inputComprobantePago" persistent-hint prepend-icon="" hide-details="auto">
										<template v-slot:append>
											<v-btn text @click="abrirDialogoArchivoComprobantePago">
												Examinar...
											</v-btn>
										</template>
									</v-file-input>
								</v-col>
								<v-col cols="12">
									<v-text-field v-model="rutPagadorComprobante" label="RUT pagador" :rules="[validarRut]"
																hint="Ejemplo: 12345678-9, sin puntos y con guión" prepend-inner-icon="fingerprint">
									</v-text-field>
								</v-col>
								<v-col cols="12">
									<v-text-field v-model="bancoComprobante" label="Nombre del banco" :rules="[validarBanco]"
																hint="Ejemplo: Banco del Sol" prepend-inner-icon="account_balance">
									</v-text-field>
								</v-col>
								<v-col cols="12">
									<v-text-field v-model="numeroCuentaComprobante" label="Número de cuenta" :rules="[validarNumeroCuenta]"
																hint="Ejemplo: 3141592" prepend-inner-icon="tag">
									</v-text-field>
								</v-col>
								<v-col cols="12">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<span	v-on="on">
												<v-checkbox v-model="noFacturarPago" label="No facturar" hide-details />
											</span>
										</template>
										<span>
											Active esta opción para que Vessi <u>no</u> emita una factura por el pago que hará aquí.
										</span>
									</v-tooltip>
								</v-col>
								<v-expand-transition>
									<v-col cols="12" v-show="codigoAutorizacionEnviado">
										<v-text-field v-model="codigoAutorizacion" label="Código de autorización" :rules="[validarCodigoAutorizacion]"
																	prepend-inner-icon="lock" hide-details="auto" :type="mostrarCodigoAutorizacion ? 'text' : 'password'"
																	@click:append="mostrarCodigoAutorizacion = !mostrarCodigoAutorizacion" ref="codigoAutorizacionInput"
																	:append-icon="mostrarCodigoAutorizacion ? 'visibility_off' : 'visibility'">
										</v-text-field>
									</v-col>
								</v-expand-transition>
								<v-col cols="12" class="d-flex justify-center">
									<v-btn small @click="enviarCodigoAutorizacion" :loading="enviandoCodigoAutorizacion" class="mt-2"
												 depressed color="primary">
										Solicitar código autorización<br>
										para {{ vendedorAsistente }}
									</v-btn>
								</v-col>
								<v-col cols="12" class="d-flex justify-center">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<v-btn color="warning" @click="cursarOrden" class="ma-1" x-large depressed
														 :disabled="!puedeTerminarVenta || cursandoOrden" v-on="on">
												<v-icon left>
													check_circle_outline
												</v-icon>
												Terminar venta
											</v-btn>
										</template>
										<span>
											Subir comprobante de pago y finalizar venta
										</span>
									</v-tooltip>
								</v-col>
							</v-row>
						</v-form>
					</v-card>
				</v-col>
			</template>
		</v-row>
		<modal-contrato :visible="modalContrato.visible" :datos-plan="datosPlan" :datos-cliente="datosCliente"
										:datos-adicionales="datosAdicionales" :cupon="cuponAplicado" @notificacion="modalContratoNotificacion"
										@acepta="modalContratoAcepta" @rechaza="modalContratoRechaza"/>
		<modal-exito-venta-asistida :visible="modalExitoVentaAsistida.visible" :id-orden="modalExitoVentaAsistida.idOrden"/>
	</v-template>
</template>

<script>
import { API } from 'aws-amplify';
import numeral from 'numeral';
import VueRecaptcha from 'vue-recaptcha';
import * as config from '@/config';
import axios from 'axios';
import Ayuda from '@/components/Ayuda';
import ModalContrato from './ModalContrato';
import ModalExitoVentaAsistida from './ModalExitoVentaAsistida';
import * as RutJs from 'rut.js';

const AUTOCONTRATAR_API_NAME = config.autocontratarApiName;
let contadorGeneracionMontos = 0;

const pesoMaximoArchivo = 10*1024*1024; // En bytes.

export default {
	components: {
		'vue-recaptcha': VueRecaptcha,
		'ayuda': Ayuda,
		'modal-contrato': ModalContrato,
		'modal-exito-venta-asistida': ModalExitoVentaAsistida,
	},
	props: {
		datosPlan: {
			type: Object,
			default: {},
		},
		datosCliente: {
			type: Object,
			default: {},
		},
		datosAdicionales: {
			type: Object,
			default: {},
		},
		activo: {
			type: Boolean,
			default: false,
		},
		vendedorEncriptado: {
			type: String,
		},
		vendedorAsistente: {
			type: String,
		},
	},
	data: () => ({
		montos: undefined,
		cargandoMontos: false,
		cargandoMediosPago: false,
		montosDesactualizados: false,
		clavePublicaRecaptcha: config.recaptchaPublicKey,
		recaptchaTokenExito: undefined,
		cursandoOrden: false,
		nombreTareaEnCurso: undefined,
		mediosPago: [],
		medioPago: undefined,
		alertaCierreVentana: false,
		pagoDesactivado: config.desactivarPago, // Valor es estático
		modalContrato: {
			visible: false,
		},
		inputCupon: undefined,
		// Venta asistida
		archivoComprobantePago: undefined,
		codigoAutorizacion: undefined,
		mostrarCodigoAutorizacion: false,
		formularioTerminarVentaValido: false,
		enviandoCodigoAutorizacion: false,
		codigoAutorizacionEnviado: false,
		rutPagadorComprobante: undefined,
		bancoComprobante: undefined,
		numeroCuentaComprobante: undefined,
		modalExitoVentaAsistida: {
			visible: false,
			idOrden: undefined,
		},
		noFacturarPago: false, // Por defecto SÍ emitirle factura al cliente
	}),
	computed: {
		cuponAplicado: function() {
			let vm = this;
			return vm.hayCupon ? vm.montos.cupon : undefined;
		},
		puedeAplicarCupon: function() {
			let vm = this;
			let inputCupon = vm.inputCupon;
			if(!inputCupon){
				// null o undefined o ''
				return false;
			}
			return (inputCupon.length > 0);
		},
		hayCupon: function() {
			let vm = this;
			let hayMontos = vm.hayMontos;
			if(!hayMontos) {
				return false;
			}
			let montos = vm.montos;
			let cupon = montos.cupon;
			let hay = (cupon !== undefined);
			return hay;
		},
		puedePagar: function() {
			let vm = this;
			let recaptchaValidado = vm.recaptchaValidado;
			let cargandoMontos = vm.cargandoMontos;
			let hayMedioPagoSeleccionado = vm.hayMedioPagoSeleccionado;
			let pagoDesactivado	= vm.pagoDesactivado;
			let puede = (recaptchaValidado && !cargandoMontos && hayMedioPagoSeleccionado && !pagoDesactivado);
			return puede;
		},
		recaptchaValidado: function() {
			let vm = this;
			// Está validado ⟺ Está el token de éxito de prueba
			return (vm.recaptchaTokenExito !== undefined);
		},
		plan: function() {
			let vm = this;
			return vm.datosPlan.plan;
		},
		cantidad: function() {
			let vm = this;
			return vm.datosPlan.cantidad;
		},
		hayMontos: function() {
			let vm = this;
			let montos = vm.montos;
			return (montos !== undefined);
		},
		hayMedioPagoSeleccionado: function() {
			let vm = this;
			let medioPago = vm.medioPago;
			return (medioPago !== undefined);
		},
		// Venta asistida
		esVentaAsistida: function() {
			let vm = this;
			let vendedorAsistente = vm.vendedorAsistente;
			let es = !!vendedorAsistente;
			return es;
		},
		puedeTerminarVenta: function() {
			let vm = this;
			const cargandoMontos = vm.cargandoMontos;
			const formularioTerminarVentaValido = vm.formularioTerminarVentaValido;
			const puede = (!cargandoMontos && formularioTerminarVentaValido);
			return puede;
		},
	},
	methods: {
		aplicarCupon: async function() {
			let vm = this;
			// Tomar cupón desde el input
			let cupon = vm.inputCupon;
			await vm.calcularMontos(cupon);
		},
		limpiarInputCupon: function() {
			let vm = this;
			let refInputCupon = vm.$refs.inputCupon;
			if(refInputCupon){
				// ref está dentro de un v-if
				refInputCupon.reset();
			}
			vm.inputCupon = undefined;
		},
		eliminarCupon: function() {
			let vm = this;
			// Solicitar montos sin cupón
			let sinCupon = undefined;
			vm.calcularMontos(sinCupon);
		},
		cursarOrden: async function() {
			let vm = this;
			vm.cursandoOrden = true;

			// 1) Iniciar orden: obtener id y urls de subida de archivos
			let inicioOrdenData;
			let tokenRecaptcha = vm.recaptchaTokenExito;
			try {
				vm.nombreTareaEnCurso = 'Obteniendo datos para iniciar orden de venta';
				inicioOrdenData = await vm.iniciarOrden(tokenRecaptcha);
			}
			catch(e) {
				const response = e.response;
				const mensajeError = response ? response.data : e.toString(); // Mensaje de error
				vm.notificar(`Error al iniciar orden: ${mensajeError}`, 'error');
				vm.cursandoOrden = false;
				return;
			}

			// Reiniciar recaptcha, token solo se puede usar una vez
			vm.reiniciarRecaptcha();

			// 2) Subir imágenes de cédula
			let archivosOrden = inicioOrdenData.archivos;
			try {
				let representante = vm.datosCliente.representante;
				let subirCedulaAnverso = vm.subirArchivo(representante.cedulaAnverso, archivosOrden.cedulaAnverso.urlSubida);
				let subirCedulaReverso = vm.subirArchivo(representante.cedulaReverso, archivosOrden.cedulaReverso.urlSubida);
				vm.nombreTareaEnCurso = 'Subiendo imagen de anverso y de reverso de cédula';
				await Promise.all([subirCedulaAnverso, subirCedulaReverso]);
			}
			catch(e) {
				const response = e.response;
				const mensajeError = response ? response.data : e.toString(); // Mensaje de error
				vm.notificar(`Error al subir archivos de cédula de identidad: ${mensajeError}`, 'error');
				vm.cursandoOrden = false;
				return;
			}

			// 3) Subir comprobante de pago, sólo se sube si es venta asistida
			let esVentaAsistida = vm.esVentaAsistida;
			if(esVentaAsistida) {
				try {
					let comprobantePago = vm.archivoComprobantePago;
					let subirComprobantePago = vm.subirArchivo(comprobantePago, archivosOrden.comprobantePago.urlSubida);
					vm.nombreTareaEnCurso = 'Subiendo comprobante de pago';
					await subirComprobantePago;
				}
				catch (e) {
					const response = e.response;
					const mensajeError = response ? response.data : e.toString(); // Mensaje de error
					vm.notificar(`Error al subir comprobante de pago: ${mensajeError}`, 'error');
					vm.cursandoOrden = false;
					return;
				}
			}

			// 4) Terminar orden, subir resto de los datos introducidos por el usuario
			let terminarOrdenData;
			try {
				vm.nombreTareaEnCurso = 'Consolidando datos y terminando orden de venta';
				terminarOrdenData = await vm.terminarOrden(inicioOrdenData);
			}
			catch(e) {
				const response = e.response;
				const mensajeError = response ? response.data : e.toString(); // Mensaje de error
				vm.notificar(`Error al terminar orden: ${mensajeError}`, 'error');
				vm.cursandoOrden = false;
				return;
			}

			// 5) Acción final para que usuario termine flujo
			if(esVentaAsistida) {
				// Venta fue asistida, vendedor asistente ya subió comprobante de pago
				// Mostrar modal de éxito, que al aceptarse redirigirá al vendedor al inicio para otra venta
				vm.modalExitoVentaAsistida.idOrden = inicioOrdenData.idOrden;
				vm.modalExitoVentaAsistida.visible = true;
				vm.cursandoOrden = false;
			}
			else {
				// Redirigir al usuario al pago
				const nombreMedioPago = vm.medioPago.nombre;
				vm.nombreTareaEnCurso = `Redirigiendo al medio de pago "${nombreMedioPago}"`;
				window.location.href = terminarOrdenData.pago.enlace;
			}
		},
		formatearMoneda: function(cifra, moneda='CLP') {
			let formateado;
			if(moneda === 'CLF') {
				formateado = numeral(cifra).format('0,0[.][0000]'); // Precaución con más de 4 decimales
			}
			else {
				// Asumir CLP
				formateado = numeral(cifra).format();
			}
			return formateado;
		},
		calcularMontos: async function(cupon) {
			// Podrían haber varias invocaciones de esta función en paralelo. Asignar a cada invocación un identificador único, lo cual
			// permite mostrarle al usuario solo el resultado de la última invocación.
			let vm = this;
			let identificadorInvocacion = ++contadorGeneracionMontos;
			//vm.montos = undefined;
			if(vm.datosPlan === undefined) {
				vm.notificar('Para calcular los montos se requiere de un plan seleccionado', 'error');
				return;
			}
			let pathMontosPlan = '/montos-plan';
			let datosPlan = vm.datosPlan;
			let datosAdicionales = vm.datosAdicionales;
			let datosCliente = vm.datosCliente;
			let empresa = datosCliente.empresa;
			let initMontosPlan = {
				headers: {},
				body: {
					datosPlan,
					datosAdicionales,
					empresa,
					cupon,
				},
			};
			vm.cargandoMontos = true;
			try {
				let response = await API.post(AUTOCONTRATAR_API_NAME, pathMontosPlan, initMontosPlan);
				if(identificadorInvocacion !== contadorGeneracionMontos) { return; } // Inhibir, simular que aún se está generando.
				vm.montos = response.montos;
				let hayCuponSolicitado = (cupon !== undefined);
				let montosSinCupon = (response.montos.cupon === undefined);
				let cuponFallo = (hayCuponSolicitado && montosSinCupon);
				if(cuponFallo) {
					// Avisar de problema, no resetear input cupón por si usuario lo escribió mal y lo corrija
					vm.notificar(`Cupón "${cupon}" no es aplicable al plan elegido, o no existe`, 'warning');
				}
				else {
					// Cupón tuvo éxito, resetear input cupón
					vm.limpiarInputCupon();
				}
			}
			catch(e) {
				if(identificadorInvocacion !== contadorGeneracionMontos) { return; } // Inhibir, simular que aún se está generando.
				vm.notificar('Error al calcular montos. Intente recargar esta página.', 'error');
			}
			vm.montosDesactualizados = false;
			vm.cargandoMontos = false;
		},
		recaptchaExpirado: function() {
			let vm = this;
			vm.recaptchaTokenExito = undefined;
		},
		recaptchaVerificado: function(response) {
			let vm = this;
			// Establecer token de éxito. Será usado para crear orden.
			vm.recaptchaTokenExito = response;
		},
		recaptchaError: function() {
			let vm = this;
			// Componente emite señal "error" pero no está documentada. Al examinar código
			// fuente, se constata que - lamentablemente - no adjunta ningún mensaje de error.
			// No queda otra que mostrar error genérico.
			vm.notificar('Ha ocurrido un problema con el reCAPTCHA. Intente reiniciarlo para proseguir.', 'error');
		},
		reiniciarRecaptcha: function() {
			let vm = this;
			vm.recaptchaTokenExito = undefined;
			let recaptchaInput = vm.$refs['recaptchaInput'];
			if(recaptchaInput) {
				recaptchaInput.reset();
			}
		},
		cargarMediosPago: async function() {
			let vm = this;
			let pathMediosPago = '/medios-pago';
			let initMediosPago = {
				headers: {},
			};
			vm.cargandoMediosPago = true;
			try {
				let response = await API.get(AUTOCONTRATAR_API_NAME, pathMediosPago, initMediosPago);
				vm.mediosPago = response.mediosPago;
				// Elegir automáticamente el primero
				vm.medioPago = vm.mediosPago[0];
			}
			catch(e) {
				vm.notificar('Error al cargar los medios de pago. Intente recargar esta página.', 'error');
			}
			vm.cargandoMediosPago = false;
		},
		iniciarOrden: async function(tokenRecaptcha) {
			let vm = this;
			let codigoAutorizacion = vm.codigoAutorizacion;
			let datosVendedor = {
				'vendedorEncriptado': vm.vendedorEncriptado, // Autoventa con link de vendedor
				'vendedorAsistente': vm.vendedorAsistente, // Venta asistida por vendedor
			};
			let datosRecaptcha = {
				tokenExito: tokenRecaptcha,
			};
			let pathIniciarOrden = '/iniciar-orden';
			let initIniciarOrden = {
				'body': {
					datosRecaptcha,
					codigoAutorizacion,
					datosVendedor,
				},
			};
			let datosInicioOrden = await API.post(AUTOCONTRATAR_API_NAME, pathIniciarOrden, initIniciarOrden);
			return datosInicioOrden;
		},
		terminarOrden: async function(datosInicioOrden) {
			let vm = this;

			// Crea la orden, la que estará de momento incompleta.
			let esVentaAsistida = vm.esVentaAsistida;
			let datosMedioPago;

			if(!esVentaAsistida) {
				datosMedioPago = {'codigo': vm.medioPago.codigo};
			}

			let datosCliente = vm.datosCliente;
			let datosPlan = vm.datosPlan;
			let cupon = vm.montos.cupon;
			let datosAdicionales = vm.datosAdicionales;
			let rutPagadorComprobante = vm.rutPagadorComprobante;
			let bancoComprobante = vm.bancoComprobante;
			let numeroCuentaComprobante = vm.numeroCuentaComprobante;
			let datosComprobante;
			if(esVentaAsistida) {
				datosComprobante = {
					rutPagador: rutPagadorComprobante,
					nombreBanco: bancoComprobante,
					numeroCuenta: numeroCuentaComprobante,
				};
			}
			let noFacturarPago = vm.noFacturarPago;
			let pathFinalizarOrden = '/finalizar-orden';
			let initFinalizarOrden = {
				headers: {},
				body: {
					datosCliente,
					datosPlan,
					datosMedioPago,
					datosAdicionales,
					cupon,
					datosComprobante,
					noFacturarPago,
					datosInicioOrden,
				},
			};

			// Subir toda la información, retorna link de pago si no es venta asistida
			let response = await API.post(AUTOCONTRATAR_API_NAME, pathFinalizarOrden, initFinalizarOrden);
			return response;
		},
		subirArchivo: async function(blob, url) {
			let init = {
				headers: {
					'Content-Type': blob.type,
				}
			};
			await axios.put(url, blob, init);
		},
		notificar: function(mensaje, tipo) {
			let vm = this;
			vm.$emit('notificacion', {mensaje, tipo});
		},
		alertarCierreVentana: function (e) {
			let vm = this;
			// Prevenir cierre accidental de ventana cuando se está preparando el pago
			// https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload#example
			if(vm.preparandoPago) {
			  e.preventDefault();
			  e.returnValue = '';
			}
			else {
				delete e['returnValue'];
			}
		},
		// Modal contrato
		modalContratoMostrar: function() {
			let vm = this;
			vm.modalContrato.visible = true;
		},
		modalContratoAcepta: function() {
			let vm = this;
			vm.modalContrato.visible = false;
			vm.cursarOrden(); // Async
		},
		modalContratoRechaza: function() {
			let vm = this;
			vm.modalContrato.visible = false;
		},
		modalContratoNotificacion: function(notificacion) {
			let vm = this;
			vm.notificar(notificacion.mensaje, notificacion.tipo);
		},
		// Venta asistida
		validarArchivoComprobantePago: function(v) {
			if((v === undefined) || (v === null)) {
				return 'Debe definirse';
			}
			let pesoBytes = v.size;
			let pesoMaximoBytes = pesoMaximoArchivo;
			let demasiadoGrande = (pesoBytes > pesoMaximoBytes);
			if(demasiadoGrande) {
				return `Archivo es demasiado grande. El máximo aceptado es ${(pesoMaximoBytes/(1024.0*1024.0)).toFixed(1)} Mib`;
			}
			return true;
		},
		abrirDialogoArchivoComprobantePago: function() {
			let vm = this;
			// ADVERTENCIA, $refs.input.click() NO está documentado, en
			// futuras actualizaciones de Vuetify esto podría quebrarse.
			vm.$refs['inputComprobantePago'].$refs.input.click();
		},
		validarCodigoAutorizacion: function(v) {
			if(!v || (v.length === 0)) {
				return `Debe definirse`;
			}
			return true;
		},
		enviarCodigoAutorizacion: async function() {
			let vm = this;
			const vendedor = vm.vendedorAsistente;
			let pathEnviarCodigo = '/venta-asistida/enviar-codigo';
			let initEnviarCodigo = {
				headers: {},
				body: {
					vendedor,
				},
			};
			vm.$refs['codigoAutorizacionInput'].reset();
			try {
				vm.enviandoCodigoAutorizacion = true;
				await API.post(AUTOCONTRATAR_API_NAME, pathEnviarCodigo, initEnviarCodigo);
				vm.notificar('Código de autorización generado y enviado exitosamente.', 'success');
				vm.codigoAutorizacionEnviado = true;
			}
			catch (err) {
				vm.notificar('Error al generar o enviar código de autorización.', 'error');
			}
			vm.enviandoCodigoAutorizacion = false;
		},
		validarRut: function(v) {
			let rutRegex = /^(\d)+-([\d|kK])$/;
			if((v === undefined) || (v === '')) {
				return 'Debe definirse';
			}
			let calza = (v.match(rutRegex) !== null);
			if(!calza) {
				return 'Debe ser sin puntos y con guión. Ejemplo: 12345678-9';
			}
			let dvValido = RutJs.validate(v);
			return dvValido ? true : 'Dígito verificador inválido';
		},
		validarBanco: function(v) {
			if((v === undefined) || (v === '')) {
				return 'Debe definirse';
			}
			return true;
		},
		validarNumeroCuenta: function(v) {
			let soloDigitosRegex = /^\d+$/;
			if((v === undefined) || (v === '')) {
				return 'Debe definirse';
			}
			let calza = (v.match(soloDigitosRegex) !== null);
			if(!calza) {
				return 'Ingrese sólo dígitos';
			}
			return true;
		},
	},
	watch: {
		cursandoOrden: function(newVal) {
			let vm = this;
			if(!newVal) {
				// Limpiar el nombre de la tarea en curso
				vm.nombreTareaEnCurso = undefined;
			}
		},
		datosPlan: {
			deep: true,
			immediate: true,
			handler: function() {
				let vm = this;
				vm.montosDesactualizados = true;
			},
		},
		datosAdicionales: {
			deep: true,
			immediate: true,
			handler: function() {
				let vm = this;
				vm.montosDesactualizados = true;
			},
		},
		datosCliente: {
			deep: true,
			immediate: true,
			handler: function() {
				let vm = this;
				let hayCupon = vm.hayCupon;
				// Cupón depende de empresa
				if(hayCupon) {
					vm.montosDesactualizados = true;
				}
			},
		},
		activo: {
			immediate: true,
			handler: function(newVal) {
				let vm = this;
				if(newVal) {
					if(vm.montosDesactualizados || !vm.hayMontos) {
						// Intentar reutilizar cupón si lo hay. Si no sirve, la API entregará
						// igualmente montos, pero calculados sin cupón. No fallará.
						let cupon = vm.hayCupon ? vm.cuponAplicado : undefined;
						vm.calcularMontos(cupon);
					}
				}
				else {
					// Limpiar input de cupón si se sale de este paso
					vm.limpiarInputCupon();
				}
			}
		},
	},
	mounted: function() {
		let vm = this;
		window.addEventListener('beforeunload', vm.alertarCierreVentana);
		vm.cargarMediosPago();
	},
	beforeDestroy: function() {
		let vm = this;
		window.removeEventListener('beforeunload', vm.alertarCierreVentana);
	}
};
</script>
